import React from "react";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Loading from "../../../../components/Loading";
import Button from "../../../../components/Button";
import { AdapterLink } from "../../../../components/Adopter";
import { useQuery } from "react-query";
import { mutateErrors } from "../../../../utils";
import Error from "../../../../components/Error";
import useSchoolQueries from "../../hooks/useSchoolQueries";
import PageHeader from "../../../../components/PageHeader";
import { Routes } from "../../../../constants/routes";
import Grid from "@material-ui/core/Grid";
import SchoolListItem from "../../components/admin/SchoolListItem";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export function ListPage() {
  const classes = useStyles();
  const { fetchAll } = useSchoolQueries();
  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("schools", fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Schools"}
          subtitle={"Here are listed schools"}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              component={AdapterLink}
              to={`/0/${Routes.SCHOOLS}/create`}
            >
              Add
            </Button>
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {data &&
            data.data.map((school: any, index) => (
              <SchoolListItem
                onDelete={refetch}
                index={index}
                school={school}
                key={`SchoolListItem_${school.id}`}
              />
            ))}
        </Grid>
      </Container>
    </>
  );
}

export default ListPage;
